var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton line",style:(_vm.style)},[_c('skeleton-base')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }